module.exports = __webpack_public_path__ + "static/media/logo.87663f38.png";